import { Apis } from "../../../lib/Apis";

export const popularInteriorDesign = () => {
    const addPopularInteriorDesign = async (data) => {
        try {
            const response = await Apis.addPopularInteriorDesign(data);
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    const getAllInteriorDesigns = async (setInteriorDesignData) => {
        try {
            const response = await Apis.getAllInteriorDesigns();
            setInteriorDesignData(response.data.data);
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };
    const getAllInteriorDesignNamesForPopularDesign = async (setInteriorDesignNames) => {
        try {
            const response = await Apis.getAllInteriorDesignNamesForPopularDesign();
            setInteriorDesignNames(response.data.data);
            return response.data;
        } catch (error) {
            console.error("Error fetching interior design names for popular design:", error);
            throw error;
        }
    };

    return {
        addPopularInteriorDesign,
        getAllInteriorDesigns,
        getAllInteriorDesignNamesForPopularDesign
    };
};
